export const getSpainData = () => ({
  name: "Espagne",
  description: "L'Espagne est l'un des plus anciens pays viticoles du monde, avec une tradition millénaire et une diversité de terroirs exceptionnelle, du nord humide au sud ensoleillé.",
  type: "country",
  regions: [
    { name: "Rioja", area: "65,000 ha", percentage: "12%", description: "Région des vins rouges prestigieux" },
    { name: "Ribera del Duero", area: "22,000 ha", percentage: "4%", description: "Vins rouges puissants" },
    { name: "Navarra", area: "18,000 ha", percentage: "3.3%", description: "Vins traditionnels et modernes" },
    { name: "Priorat", area: "2,000 ha", percentage: "0.4%", description: "Vins de montagne" },
    { name: "Rías Baixas", area: "4,000 ha", percentage: "0.7%", description: "Vins blancs de l'Atlantique" },
    { name: "Rueda", area: "15,000 ha", percentage: "2.8%", description: "Vins blancs de Verdejo" },
    { name: "Cava", area: "32,000 ha", percentage: "5.9%", description: "Vins effervescents" },
    { name: "Jerez", area: "7,000 ha", percentage: "1.3%", description: "Vins fortifiés" },
    { name: "Autres", area: "370,000 ha", percentage: "69.6%", description: "Régions diverses" }
  ],
  mapAreas: [
    { region: "Rioja", x: -2.5, y: 42.5, color: "#4B164C", size: 8 },
    { region: "Ribera del Duero", x: -4.0, y: 41.8, color: "#6d2c7a", size: 6 },
    { region: "Navarra", x: -1.5, y: 42.8, color: "#8a4a8a", size: 5 },
    { region: "Priorat", x: 0.8, y: 41.2, color: "#a768a6", size: 3 },
    { region: "Rías Baixas", x: -8.5, y: 42.5, color: "#c486c4", size: 4 },
    { region: "Rueda", x: -4.5, y: 41.2, color: "#e2a4e2", size: 5 },
    { region: "Cava", x: 1.8, y: 41.5, color: "#f0c2f0", size: 6 },
    { region: "Jerez", x: -6.0, y: 36.7, color: "#f8e0f8", size: 4 }
  ],
  statistics: {
    totalArea: "950,000 ha",
    production: "35 million hectolitres",
    regions: "70+ régions viticoles",
    appellations: "96 appellations d'origine",
    exportPercentage: "25%"
  },
  characteristics: {
    climate: "Diversité climatique : océanique au nord, continental au centre, méditerranéen au sud",
    soil: "Variété géologique : calcaires, argiles, schistes, granit, sable",
    viticulture: "Tradition ancienne, techniques modernes, respect du terroir"
  },
  wineStyles: {
    red: "Vins rouges structurés et complexes, du fruité au tannique, avec un excellent potentiel de vieillissement",
    white: "Vins blancs secs et aromatiques, de la fraîcheur atlantique à la complexité méditerranéenne",
    rosé: "Rosés fruités et équilibrés, parfaits pour l'apéritif et la cuisine",
    sparkling: "Cava et vins effervescents de qualité, alternative au champagne"
  },
  history: "La viticulture espagnole remonte aux Phéniciens et aux Romains. Au Moyen Âge, les monastères ont préservé et développé les techniques viticoles. Le XIXe siècle a vu l'émergence des grandes bodegas et l'exportation vers l'Europe. Aujourd'hui, l'Espagne combine tradition millénaire et innovation moderne.",
  foodPairing: "Tapas, paella, viandes grillées, fromages affinés, cuisine méditerranéenne"
}); 